import { useState, useEffect } from "react";

const QuizTimer = (props) => {
  const [[hrs, mins, secs], setTime] = useState([
    props.hours,
    props.minutes,
    props.seconds,
  ]);
  const [timeOut, setTimeOut] = useState("");

  const tick = () => {
    if (hrs === 0 && mins === 0 && secs === 0) {
      setTimeOut("timeout");
    } else if (mins === 0 && secs === 0) {
      setTime([hrs - 1, 59, 59]);
    } else if (secs === 0) {
      setTime([hrs, mins - 1, 59]);
    } else {
      setTime([hrs, mins, secs - 1]);
    }
  };

  useEffect(() => {
    const timerId = setInterval(tick, 1000);
    return () => clearInterval(timerId);
  }, [hrs, mins, secs]);

  useEffect(() => {
    if (timeOut) {
      props.setQuizStatus(timeOut);
    }
  }, [timeOut, props]);

  // Format time display based on whether hours exist
  const formatTime = () => {
    if (hrs > 0) {
      return `${hrs.toString().padStart(2, "0")}:${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
    } else {
      return `${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
    }
  };

  return (
    <div>
      <span className="text-danger">
        <i className="fe fe-clock me-1 align-middle"></i>
        {formatTime()}
      </span>
    </div>
  );
};

export default QuizTimer;